import React from 'react'
import { connect } from 'react-redux'
import {
  Field,
  Form,
  reduxForm,
  change,
  getFormValues,
  formValueSelector
} from 'redux-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router-dom'

import {
  buildTooltipText,
  buildShortText,
  getAllClassroomsOfYear
} from '../../utils/childrenClassrooms'
import {
  occupationsArray,
  roles,
  colors,
  roomDepartment
} from '../../utils/constants'
import ReactSelect from '../select/ReactSelect'
import Button from '../button/Button'
import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'
import AsyncSelect from '../shared/AsyncSelect'
import CreateChatGroupForm from './CreateChatGroupForm'
import CheckboxInput from '../input/CheckboxInput'

import { getHighestPriorityRole, numberFromText } from '../../utils/helpers'
import { occupationsObject } from '../../utils/dicts'
import { createChatRSPA } from '../../store/chats/actions'
import { getFilteredContacts } from '../../store/users/actions'
import searchIcon from '../../assets/icons/search-icon.svg'
import removeButton from '../../assets/icons/rounded-add-cross-icon.svg'
import roundedWarning from '../../assets/icons/rounded-outlined-warning.svg'
import familyIcon from '../../assets/icons/family-icon.svg'
import CircularProgress from '@material-ui/core/CircularProgress'

import { Avatar, makeStyles, Tooltip } from '@material-ui/core'
import { AvatarGroup } from '@material-ui/lab'
import Input from '@material-ui/core/Input'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflow: 'hidden'
  },
  group_form_root: {
    height: '85%',
    width: '100%'
  },
  header: {
    backgroundColor: '#ADB8CC33',
    color: '#386093',
    padding: '15px 40px',
    '& h1': {
      margin: 0,
      fontWeight: '700',
      fontSize: 16
    }
  },
  destinations_section: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '20px 40px',
    position: 'relative',
    '& .label': {
      margin: 0
    },
    [theme.breakpoints.down('1000')]: {
      padding: '10px 20px'
    }
  },
  avatar: {
    height: '30px',
    width: '30px',
    '& p': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      letterSpacing: '0em',
      textAlign: 'left'
    }
  },
  add_member: {
    margin: 0,
    borderRadius: 4,
    padding: 4,
    backgroundColor: '#EFF0F2',
    cursor: 'pointer',
    [theme.breakpoints.down('1000')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.down('856')]: {
      fontSize: '10px'
    },
    [theme.breakpoints.down('600')]: {
      fontSize: '12px'
    }
  },
  destination_form: {
    cursor: 'default',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    top: '-50px',
    left: '11px',
    height: '80vh',
    width: '90%',
    border: '1px solid #ADB8CC',
    boxShadow: `
      0px 13px 29px 0px #0000001A,
      0px 52px 52px 0px #00000017,
      0px 117px 70px 0px #0000000D,
      0px 208px 83px 0px #00000003,
      0px 326px 91px 0px #00000000
    `,
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    columnGap: 16,
    rowGap: 12
  },
  createMsgWarning: {
    display: 'flex',
    columnGap: 12,
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: '#FFE9DD',
    borderRadius: 4,
    marginTop: 20,
    '& p': {
      margin: 0,
      color: '#555555',
      fontWeight: 500,
      fontSize: 14
    },
    '& svg': {
      '& path': {
        fill: '#555555'
      }
    }
  },
  loadingContactsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40vh',
    textAlign: 'center'
  },
  horizontal_bar: {
    width: '100%',
    height: 1,
    borderBottom: '2px solid #EFF0F2'
  },
  form_wrapper: {
    width: '100%',
    padding: '32px 28px 0px'
  },
  filter_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    marginBottom: 0,
    rowGap: 12,
    '& h1.label': {
      fontSize: 14,
      fontWeight: '400',
      margin: 0,
      lineHeight: '100%',
      color: '#000000'
    }
  },
  async_select_class: {
    width: '100%',
    minHeight: 33,
    '& .select__control, .select__indicators, .select__value-container': {
      minHeight: '33px !important',
      height: '33px !important'
    },
    '& .select__placeholder': {
      color: '#386093 !important',
      fontSize: '14px !important'
    }
  },
  contacts_list: {
    width: '100%',
    marginTop: 12
  },
  checked: {
    '& svg': {
      fill: '#386093'
    }
  },
  contact: {
    margin: '2px 0px',
    padding: '8px 0px 8px 15px',
    display: 'flex',
    gap: 8,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#ADB8CC33'
    },
    '& h1.user_name': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555',
      transition: 'color 0.3s ease-in-out'
    },
    '& p.user_occupation': {
      fontWeight: 400,
      fontSize: 12,
      color: '#9B9B9B',
      transition: 'color 0.3s ease-in-out'
    }
  },
  contact_seleted: {
    '& h1.user_name': {
      fontWeight: 700,
      color: '#386093'
    },
    '& p.user_occupation': {
      color: '#386093'
    },
    backgroundColor: '#DAEEF1',
    '&:hover': {
      backgroundColor: '#DAEEF1'
    }
  },
  contact_name: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& h1': {
      margin: 0
    },
    '& p': {
      margin: 0
    }
  },
  roomMember: {
    borderRadius: 8,
    border: '1px solid #375F92',
    display: 'flex',
    alignItems: 'center',
    height: 30,
    padding: 8,
    gap: 8,
    '& .remove_member': {
      cursor: 'pointer',
      transform: 'rotate(135deg)',
      '& path': {
        fill: '#375F92'
      }
    }
  },
  membersQuantityWrapper: {
    display: 'flex',
    columnGap: 4,
    '& p': {
      color: '#ADB8CC',
      fontSize: 12,
      fontWeight: 400,
      margin: 0
    }
  },
  membersSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    marginTop: 4
  },
  membersSection: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
    maxHeight: 60,
    overflowY: 'auto'
  },
  search_component: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  search_by_name: {
    gridColumn: '1 / -1'
  },
  bottomBtn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 36px'
  },
  rootBtn: {
    width: 'fit-content',
    alignSelf: 'flex-end'
  },
  createRoomBtn: {
    backgroundColor: '#386093',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  edit_members: {
    fontWeight: 600,
    fontSize: 14,
    textDecoration: 'underline',
    color: '#386093',
    textDecorationColor: '#386093',
    cursor: 'pointer',
    margin: 0
  },
  header_wrapper: {
    height: '15%'
  },
  react_multiple_select: {
    height: 'auto',
    minHeight: '33px'
  },
  react_select_root: {
    height: 33
  },
  react_select: {
    width: '100%',
    height: '100%',
    '& .select__control, .select__indicators': {
      minHeight: 'unset !important',
      height: '100%',
      overflowY: 'hidden'
    }
  },
  end_message: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 30
  }
}))

const CreateChatForm = ({
  handleSubmit,
  onSubmit,
  touch,
  change,
  fieldValues,
  handleUnselectForms,
  userOccupations,
  createChatRSPA,
  currentUserId,
  schoolId,
  classroomValue,
  gradeValue,
  occupationValue,
  projectId,
  afterCreateChat,
  getFilteredContacts
}) => {
  const classes = useStyles()
  const history = useHistory()
  const modalRef = React.useRef(null)
  const selectGradeRef = React.useRef(null)
  const selectClassroomRef = React.useRef(null)
  const selectOccupationRef = React.useRef(null)
  const [inputExpanded, setInputExpanded] = React.useState(true)
  const [currentContactPage, setCurrentContactPage] = React.useState(1)
  const [contactNameFilter, setContactNameFilter] = React.useState('')
  const [contacts, setContacts] = React.useState([])
  const [contactsMeta, setContactsMeta] = React.useState(null)
  const [errorSearchName, setErrorSearchName] = React.useState('')
  const [selectedUsers, setSelectedUsers] = React.useState([])
  const [dataToCreateGroup, setDataToCreateGroup] = React.useState(null)
  const CURRENT_YEAR = new Date().getFullYear()

  const hasSelectedUser = selectedUsers.length > 0
  const isGroupMessage = selectedUsers.length > 1

  const [isLoading, setIsLoading] = React.useState(false)
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const defaultParams = {
    'q[id_not_in]': currentUserId
  }
  const searchParams = {
    ...(occupationValue && {
      'q[occupations_ids]': occupationValue.map(item => item.value)
    }),
    ...(gradeValue && { 'q[grade_id]': gradeValue }),
    ...(classroomValue && { 'q[classroom_id]': classroomValue })
  }

  const currentUserPriorityOccupation = getHighestPriorityRole(
    userOccupations.map(item => item)
  )
  const project_id = +projectId || +process.env.REACT_APP_PROJECT_ID

  React.useEffect(
    () => {
      function handleClickOutside (event) {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          setInputExpanded(false)
        }
      }

      if (inputExpanded) {
        document.addEventListener('mousedown', handleClickOutside)
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    },
    [inputExpanded]
  )

  React.useEffect(() => {
    const fetchContacts = async () => {
      setIsLoading(true)
      await getUsersFiltered(currentContactPage, res => {
        setContacts(res)
      })
      setIsLoading(false)
    }
    fetchContacts()
  }, [])

  React.useEffect(
    () => {
      if (occupationValue || gradeValue || classroomValue) {
        handleSearchByFilters()
      }
    },
    [gradeValue, occupationValue, classroomValue]
  )

  const getUsersFiltered = async (page, processData, params) => {
    await getFilteredContacts({
      params: {
        ...defaultParams,
        ...searchParams,
        page: page,
        include: 'user_occupations.occupation',
        ...params
      }
    })
      .then(res => {
        setContactsMeta(res?.meta)
        processData(res.data)
        setIsLoading(false)
      })
      .catch(error => {
        console.error(error)
        setContactsMeta({ total_count: null, page_count: null })
        setErrorSearchName(error[0]?.detail)
        processData([])
        setIsLoading(false)
      })
  }

  const handleSearchByFilters = () => {
    setIsLoading(true)
    setCurrentContactPage(1)
    getUsersFiltered(
      1,
      res => {
        setContacts(res)
      },
      { 'q[name_cont]': contactNameFilter }
    )
  }

  const handleSeachByName = event => {
    setContactNameFilter(event.target.value)
  }

  const handleChange = (event, input) => {
    const inputName = input.name
    touch(inputName)

    let newValue
    if (Array.isArray(event)) {
      newValue = event?.map(v => v)
    } else {
      newValue = event ? event.value : ''
    }
    if (inputName === 'grade_id' && !newValue) {
      selectClassroomRef.current?.select.clearValue()
    }
    change(input.name, newValue)
  }

  const fetchMoreContactsFiltered = async page => {
    getUsersFiltered(page, res => {
      setContacts(prev => {
        return prev.concat(res)
      })
      setCurrentContactPage(currentContactPage + 1)
    })
  }

  const handleCreateRoom = () => {
    if (isGroupMessage) {
      handleSelectGroupContact()
    } else if (hasSelectedUser) {
      handleSelectDirectContact(selectedUsers[0])
    }
  }

  const handleSelectGroupContact = async () => {
    const newChat = {
      app_id: project_id,
      intervention: false,
      room_participants_attributes: [
        {
          user_id: currentUserId,
          is_moderator: !!isAdmin,
          occupation_name: currentUserPriorityOccupation
        },
        ...selectedUsers.map(item => {
          return {
            user_id: item.user_id,
            is_moderator: false,
            occupation_name: item.user_occupation
          }
        })
      ]
    }
    setDataToCreateGroup(newChat)
    setInputExpanded(!inputExpanded)
  }

  const handleSelectDirectContact = async user => {
    const newChat = {
      app_id: project_id,
      intervention: false,
      room_type: 1,
      room_department: roomDepartment?.[currentUserPriorityOccupation] || 0,
      room_participants_attributes: [
        {
          user_id: currentUserId,
          is_moderator: !!isAdmin,
          occupation_name: currentUserPriorityOccupation
        },
        {
          user_id: user.user_id,
          is_moderator: false,
          occupation_name: user.user_occupation
        }
      ]
    }
    const response = await createChatRSPA(newChat).then(res => res)
    if (response?.data?.data?.id) {
      afterCreateChat(response.data.data)
    }
  }

  const handleCheck = (event, user) => {
    setSelectedUsers(prevSelected => {
      if (event.target.checked) {
        return [
          ...prevSelected,
          {
            user_id: user.id,
            user_name: user.name,
            user_avatar: user.avatar_url,
            user_occupation: getHighestPriorityRole(
              user.user_occupations.map(item => item.occupation.name)
            )
          }
        ]
      } else {
        return prevSelected.filter(u => u.user_id !== user.id)
      }
    })
  }

  return (
    <Form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.root}>
        <div style={{ height: 'auto' }}>
          <div className={classes.header_wrapper}>
            <div className={classes.header}>
              <h1>Nova sala</h1>
            </div>
            <div className={classes.destinations_section}>
              <p className='label'>Membros</p>
              {isGroupMessage && !inputExpanded ? (
                <>
                  <AvatarGroup max={5} spacing={1}>
                    {selectedUsers.map((user, idx) => {
                      const index =
                        numberFromText(user.user_name?.slice(0, 2)) %
                        colors.length
                      return (
                        <Tooltip
                          key={`user[${idx}]`}
                          title={user.user_name}
                          arial-label='usuario'
                        >
                          <Avatar
                            src={user?.user_avatar}
                            className={classes.avatar}
                            style={{
                              backgroundColor:
                                // eslint-disable-next-line standard/computed-property-even-spacing
                                colors[index]
                            }}
                          >
                            <p className='name'>{user.user_name[0]}</p>
                          </Avatar>
                        </Tooltip>
                      )
                    })}
                  </AvatarGroup>
                  <p
                    onClick={() => setInputExpanded(true)}
                    className={classes.edit_members}
                  >
                    Editar
                  </p>
                </>
              ) : (
                <p
                  onClick={() => setInputExpanded(!inputExpanded)}
                  className={classes.add_member}
                >
                  Clique aqui para adicionar membros
                </p>
              )}
              {inputExpanded && (
                <div
                  ref={modalRef}
                  className={`${classes.destination_form} 
                `}
                >
                  <div className={classes.form_wrapper}>
                    <div className={classes.filter_wrapper}>
                      <h1 className='label'>Filtros</h1>
                      <div className={classes.filters}>
                        <Field
                          component={AsyncSelect}
                          rootStyle={classes.async_select_class}
                          defaultOptions={false}
                          isClearable
                          id='grade_id'
                          name='grade_id'
                          placeholder='Série'
                          selectRef={selectGradeRef}
                          handleAsyncChange={handleChange}
                          searchParam='q[name_cont]'
                          request={{
                            path: 'grade',
                            params: {
                              'q[classrooms_school_id_in]': schoolId
                            }
                          }}
                          touch={touch}
                        />
                        <Field
                          component={AsyncSelect}
                          rootStyle={classes.async_select_class}
                          defaultOptions={false}
                          isClearable
                          id='classroom_id'
                          name='classroom_id'
                          placeholder='Turma'
                          selectRef={selectClassroomRef}
                          handleAsyncChange={handleChange}
                          cacheUniqs={[gradeValue]}
                          searchParam='q[name_cont]'
                          request={{
                            path: 'classroom',
                            params: {
                              'q[grade_id_in]': gradeValue,
                              'q[school_id_in]': schoolId,
                              'q[year_lteq]': new Date().getFullYear() + 1,
                              'q[year_gteq]': new Date().getFullYear()
                            }
                          }}
                          touch={touch}
                        />
                        <Field
                          component={ReactSelect}
                          id='occupation_id'
                          name='occupation_id'
                          placeholder='Ocupação'
                          handleChange={handleChange}
                          componentClass={classes.react_select}
                          rootClass={
                            occupationValue?.length > 1
                              ? classes.react_multiple_select
                              : classes.react_select_root
                          }
                          selectRef={selectOccupationRef}
                          defaultValue={occupationValue}
                          touch={touch}
                          multiple
                          options={occupationsArray.map(item => {
                            return {
                              label: item[1],
                              value: item[0]
                            }
                          })}
                        />
                        <div className={classes.search_by_name}>
                          <Input
                            disableUnderline
                            value={contactNameFilter}
                            className={classes.search_component}
                            placeholder='Busque pelo nome'
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                handleSearchByFilters()
                              }
                            }}
                            onChange={e => handleSeachByName(e)}
                            startAdornment={
                              <StyledSVG
                                style={{ marginRight: 4 }}
                                src={searchIcon}
                                width={18}
                                height={18}
                              />
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className={classes.createMsgWarning}>
                      <StyledSVG src={roundedWarning} height={20} width={20} />
                      <p>Ao clicar em dois ou mais contatos formam um grupo</p>
                    </div>
                    {hasSelectedUser && (
                      <div className={classes.membersSectionWrapper}>
                        <div className={classes.membersQuantityWrapper}>
                          <StyledSVG src={familyIcon} width={16} height={16} />
                          <p>{selectedUsers.length} selecionados</p>
                        </div>
                        <div className={classes.membersSection}>
                          {selectedUsers.map((item, index) => {
                            return (
                              <div key={index} className={classes.roomMember}>
                                <UserAvatar
                                  avatarStyle={{ width: 24, height: 24 }}
                                  avatarUrl={item?.user_avatar}
                                  userName={item.user_name}
                                />
                                <StyledSVG
                                  className='remove_member'
                                  onClick={() =>
                                    setSelectedUsers(prev => {
                                      return prev.filter(
                                        i => +i.user_id !== +item.user_id
                                      )
                                    })
                                  }
                                  src={removeButton}
                                  width={16}
                                  height={16}
                                />
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                  {isLoading ? (
                    <div className={classes.contacts_list}>
                      <div className={classes.horizontal_bar} />
                      <div className={classes.loadingContactsWrapper}>
                        <CircularProgress
                          size={30}
                          disableShrink
                          thickness={4}
                        />
                      </div>
                      <div className={classes.horizontal_bar} />
                    </div>
                  ) : (
                    <div className={classes.contacts_list}>
                      <div className={classes.horizontal_bar} />
                      <InfiniteScroll
                        dataLength={contacts.length}
                        next={() =>
                          fetchMoreContactsFiltered(currentContactPage + 1)
                        }
                        height='40vh'
                        hasMore={contactsMeta?.total_count > contacts.length}
                        loader={
                          <div className={classes.end_message}>
                            <CircularProgress
                              size={30}
                              disableShrink
                              thickness={4}
                            />
                          </div>
                        }
                        endMessage={
                          <p className={classes.end_message}>
                            {(contactsMeta?.total_count === contacts.length) &
                            (contacts.length > 0) ? (
                              <b>Todos os contatos carregados.</b>
                            ) : errorSearchName ? (
                              <b>{errorSearchName}</b>
                            ) : (
                              <b>Nenhum contato encontrado.</b>
                            )}
                          </p>
                        }
                      >
                        {contacts.map((item, index) => {
                          const isSelected = selectedUsers.some(
                            u => u.user_id === item.id
                          )

                          const childParentsDetails = buildTooltipText(
                            item.children
                          )
                          const childParentsDetailsShort = buildShortText(
                            item.children,
                            200
                          )
                          const fullClassroomsDetails = getAllClassroomsOfYear(
                            item.classrooms,
                            CURRENT_YEAR
                          )
                            .map(item => item.name)
                            .join(', ')
                          const classroomsDetailsShort =
                            fullClassroomsDetails.length > 200
                              ? `${fullClassroomsDetails.slice(0, 200)}...`
                              : fullClassroomsDetails

                          return (
                            <div
                              className={`${classes.contact} ${isSelected &&
                                classes.contact_seleted}`}
                              key={index}
                            >
                              <CheckboxInput
                                name={`user_${item.id}`}
                                checked={isSelected}
                                handleCheck={event => handleCheck(event, item)}
                                rootClass={isSelected && classes.checked}
                              />
                              <UserAvatar
                                avatarUrl={item?.avatar_url}
                                userName={item.name}
                                withoutUserName
                              />
                              <div className={classes.contact_name}>
                                <h1 className='user_name'>{item.name}</h1>
                                {(item.user_occupations || [])
                                  .filter(
                                    (itemOccupation, idx, self) =>
                                      self.findIndex(
                                        o =>
                                          o.occupation.name ===
                                          itemOccupation.occupation.name
                                      ) === idx
                                  )
                                  .map((itemOccupation, i) => {
                                    const isTeacher =
                                      +itemOccupation.occupation_id === 8
                                    const isParent =
                                      +itemOccupation.occupation_id === 10

                                    const defaultFormat =
                                      occupationsObject[
                                        itemOccupation.occupation.name
                                      ]
                                    const customFormat = `${
                                      occupationsObject[
                                        itemOccupation.occupation.name
                                      ]
                                    }: ${
                                      isTeacher
                                        ? classroomsDetailsShort
                                        : childParentsDetailsShort
                                    }`

                                    const customTooltip = isTeacher
                                      ? fullClassroomsDetails
                                      : childParentsDetails

                                    return (
                                      <Tooltip
                                        key={i}
                                        title={
                                          isParent || isTeacher
                                            ? customTooltip
                                            : ''
                                        }
                                      >
                                        <p className='user_occupation'>
                                          {isParent || isTeacher
                                            ? customFormat
                                            : defaultFormat}
                                        </p>
                                      </Tooltip>
                                    )
                                  })}
                              </div>
                            </div>
                          )
                        })}
                      </InfiniteScroll>
                      <div className={classes.horizontal_bar} />
                    </div>
                  )}
                  <div className={classes.bottomBtn}>
                    <Button
                      rootClass={classes.rootBtn}
                      className={classes.createRoomBtn}
                      onClick={handleCreateRoom}
                      disabled={!hasSelectedUser}
                    >
                      {isGroupMessage ? 'Continuar' : 'Iniciar conversa'}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={classes.horizontal_bar} />
        {isGroupMessage && (
          <div className={classes.group_form_root}>
            <CreateChatGroupForm
              afterCreateChat={afterCreateChat}
              priorityOccupation={currentUserPriorityOccupation}
              history={history}
              handleUnselectForms={handleUnselectForms}
              createChatRSPA={createChatRSPA}
              dataToCreateGroup={dataToCreateGroup}
              selectedUsers={selectedUsers}
              setDataToCreateGroup={setDataToCreateGroup}
              currentUserId={currentUserId}
              change={change}
              fieldValues={fieldValues}
            />
          </div>
        )}
      </div>
    </Form>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('createChatForm')
  return {
    userOccupations: state.auth.currentOccupation,
    fieldValues: getFormValues('createChatForm')(state),
    currentUserId: state?.auth?.user?.data?.id,
    schoolId: state.school?.currentSchool?.school_id,
    classroomValue: selector(state, 'classroom_id'),
    gradeValue: selector(state, 'grade_id'),
    occupationValue: selector(state, 'occupation_id'),
    projectId: state?.auth?.projectId
  }
}

const mapDispatchToProps = dispatch => ({
  createChatRSPA: data => dispatch(createChatRSPA.request(data)),
  change: (field, data) => dispatch(change('createChatForm', field, data)),
  getFilteredContacts: data => dispatch(getFilteredContacts.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createChatForm',
    onSubmit: async (values, dispatch, props) => {}
  })(CreateChatForm)
)
